import http from '../../services/http-common';


// ✅ Add these imports (Syncfusion PDF)
import {
  PdfDocument, PdfPageSize,
  PdfStandardFont, PdfFontFamily, PdfFontStyle,
  PdfGrid, PdfPen, PdfColor, PdfSolidBrush,
  PdfStringFormat, PdfTextAlignment, PdfVerticalAlignment,
  PdfBitmap
} from "@syncfusion/ej2-pdf-export";
import { PdfPageOrientation } from "@syncfusion/ej2-pdf-export";

import moment from 'moment';
class InvoiceService {

  getForList(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/Invoice/list?${queryParams}`);
  }

  getInvoiceDetail(data) {
        let queryParams = new URLSearchParams(data).toString();

    return http.get(`/Invoice/InvoiceDetail?${queryParams}`);
  }

  getNextInvoiceID(InvoiceType = 'SS') {
    return http.get(`/Invoice/NextInvoiceID?InvoiceType=${InvoiceType}`);
  }

  // Dropdown sources (optional)
  getBuyerDDSource() {
    return http.get(`/Invoice/BuyerDDSource`);
  }
  getHSCodeDDSource() {
    return http.get(`/Invoice/HSCodeDDSource`);
  }
  getUnitOfMeasurementDDSource() {
    return http.get(`/Invoice/UnitOfMeasurementDDSource`);
  }

  addRecords(data) {
    return http.post(`/Invoice/add`, data);
  }

  updateMainData(data) {
    return http.put(`/Invoice/update`, data);
  }

  updateDetailData(data) {
    return http.put(`/Invoice/update-detail`, data);
  }

  
// =========================
// REPORT (Preview / PDF)
// =========================

toNum(v) {
  const n = parseFloat(String(v ?? "0").replace(/,/g, ""));
  return isNaN(n) ? 0 : n;
}



async generateInvoiceReportPDF(mainRow, detailRows, blob) {
  const doc = new PdfDocument();
  doc.pageSettings.size = PdfPageSize.a4;
  doc.pageSettings.orientation = PdfPageOrientation.Portrait;
  doc.pageSettings.margins.all = 8;

  const page = doc.pages.add();
  const g = page.graphics;

  const black = new PdfSolidBrush(new PdfColor(0, 0, 0));
  const linePen = new PdfPen(new PdfColor(0, 0, 0), 1);
  const outerPen = new PdfPen(new PdfColor(0, 0, 0), 1.2);

  const fontTitle = new PdfStandardFont(PdfFontFamily.Helvetica, 14, PdfFontStyle.Bold);
  const fontBold = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
  const font = new PdfStandardFont(PdfFontFamily.Helvetica, 7);

  const pageW = page.getClientSize().width;

  const x0 = 8;
  const xR = pageW - 8;
  const usableW = xR - x0;

  const txt = (v) => {
    const s = String(v ?? "").trim();
    return s ? s : "";
  };

  const toNum = (v) => {
    const n = parseFloat(String(v ?? "0").replace(/,/g, ""));
    return isNaN(n) ? 0 : n;
  };

  const textW = (fnt, s) => {
    try {
      return fnt.measureString(String(s)).width || 0;
    } catch {
      return String(s).length * 5;
    }
  };

  const drawField = (caption, value, capX, y, lineEndX) => {
    const capText = `${(caption || '').toUpperCase()} :`;
    g.drawString(capText, fontBold, null, black, capX, y);
    const startX = capX + textW(fontBold, capText) + 6;
    g.drawLine(linePen, startX, y + 11, lineEndX, y + 11);
    g.drawString(txt(String(value || '').toUpperCase()), font, null, black, startX + 2, y);
  };

  // =========================
  // CHANGE 7: FBR Logo (top-left) + QR Code (top-right)
  // =========================
  const blobToBase64 = (b) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(',')[1]);
      reader.onerror = reject;
      reader.readAsDataURL(b);
    });
  };

  const logoSize = 60;
  let y = 10;

  // FBR Logo - top left
  try {
    const FBRIMGresponse = await fetch('/fbr-img.jpg');
    if (FBRIMGresponse.ok) {
      const FBRimageBlob = await FBRIMGresponse.blob();
      const FBRimageBase64 = await blobToBase64(FBRimageBlob);
      const FBRimage = new PdfBitmap(FBRimageBase64);
      g.drawImage(FBRimage, x0, y, logoSize, logoSize);
    }
  } catch (e) { console.warn("FBR logo load failed", e); }

  // QR Code - top right (blob passed as parameter)
  try {
    if (blob) {
      const url = URL.createObjectURL(blob);
      const response = await fetch(url);
      if (response.ok) {
        const imageBlob = await response.blob();
        const imageBase64 = await blobToBase64(imageBlob);
        const qrImage = new PdfBitmap(imageBase64);
        g.drawImage(qrImage, pageW - logoSize - x0, y+5, logoSize + 20, logoSize + 20);
        URL.revokeObjectURL(url);
      }
    }
  } catch (e) { console.warn("QR code load failed", e); }

  // =========================
  // HEADER (Company info centered, logos on sides)
  // =========================
  const companyName = txt((mainRow?.sellerBusinessName || '').toUpperCase());
  const sellerNTN = txt((mainRow?.sellerNTNCNIC || '').toUpperCase());
  const sellerAddress = txt((mainRow?.sellerAddress || '').toUpperCase());

  // Company Name (center)
  const fontCompany = new PdfStandardFont(PdfFontFamily.Helvetica, 18, PdfFontStyle.Bold);
  const wCompany = fontCompany.measureString(companyName).width;
  g.drawString(companyName, fontCompany, null, black, (pageW - wCompany) / 2, y);
  y += 22;

  // NTN (center)
  const ntnLine = (`NTN: ${sellerNTN}`).toUpperCase();
  const fontNTN = new PdfStandardFont(PdfFontFamily.Helvetica, 13, PdfFontStyle.Bold);
  const wNTN = fontNTN.measureString(ntnLine).width;
  g.drawString(ntnLine, fontNTN, null, black, (pageW - wNTN) / 2, y);
  y += 20;

  // Address (center)
  const fontAddress = new PdfStandardFont(PdfFontFamily.Helvetica, 13, PdfFontStyle.Bold);
  const wAddr = fontAddress.measureString(sellerAddress).width;
  g.drawString(sellerAddress, fontAddress, null, black, (pageW - wAddr) / 2, y);
  y += 18;

  // Invoice heading (center)
  const invoiceTitle = mainRow?.InvoiceType == "SS" ? "SALES TAX INVOICE" : "PURCHASE TAX INVOICE";
  const wInv = fontTitle.measureString(invoiceTitle).width;
  g.drawString(invoiceTitle, fontTitle, null, black, (pageW - wInv) / 2, y);
  y += 28;

  // =========================
  // CHANGE 4: Invoice No | Date | Reference No. (ChallanNo) — ONE ROW
  // =========================
  const invoiceNo = txt(mainRow?.InvoiceID);
  const invDate = mainRow?.InvoiceDate
    ? moment(mainRow.InvoiceDate).format("DD-MMM-YYYY")
    : "";
  const challanNo = txt(mainRow?.ChallanNo);

  // 3 fields in one row: Invoice No (0-33%), Date (33-66%), Reference No. (66-100%)
  const col3W = Math.floor(usableW / 3);
  drawField("Invoice No",    invoiceNo,  x0,                   y, x0 + col3W - 8);
  drawField("Date",          invDate,    x0 + col3W,           y, x0 + col3W * 2 - 8);
  drawField("Reference No.", challanNo,  x0 + col3W * 2,       y, xR);
  y += 25;

  // =========================
  // CHANGE 5: Buyer + FBRSaleInvoiceNo in ONE ROW
  // =========================
  let captionCondition = mainRow?.InvoiceType == "SS" ? "Buyer's Name" : "Seller Name";
  const buyerEndX = x0 + Math.floor(usableW * 0.55);
  drawField(captionCondition,     (mainRow?.buyerBusinessName || mainRow?.BuyerNTNCNIC), x0,        y, buyerEndX);
  drawField("FBR Invoice No.",    mainRow?.FBRSaleInvoiceNo,                             buyerEndX + 4, y, xR);
  y += 25;

  // Address
  drawField("Address", mainRow?.buyerAddress, x0, y, xR);
  y += 25;

  // Phone + Sales Tax + NTN (3 fields, no overlap)
  const phoneCapX    = x0;
  const salesTaxCapX = x0 + Math.floor(usableW * 0.34);
  const ntnCapX      = x0 + Math.floor(usableW * 0.68);

  drawField("Phone #",          mainRow?.buyerContactNumber, phoneCapX,    y, salesTaxCapX - 12);
  drawField("Sales Tax Regn #", mainRow?.buyerSTRN,          salesTaxCapX, y, ntnCapX - 12);
  drawField("N.T.N #",          mainRow?.BuyerNTNCNIC,        ntnCapX,      y, xR);
  y += 25;

  // =========================
  // CHANGE 6: REMARKS — full row, below NTN
  // =========================
  drawField("Remarks", mainRow?.Remarks, x0, y, xR);
  y += 25;

  // =========================
  // CHANGE 1 & 2: TABLE — Remove FBR QTY/UNIT, Add HSCODE after UNIT
  // New columns: QUANTITY | UNIT | HSCODE | DESCRIPTION | UNIT PRICE | VALUE | TAX RATE | TAX AMT | TOTAL
  // =========================
  const clientW  = page.getClientSize().width;
  const tableX   = 0;
  const tableW   = clientW;
  const grid     = new PdfGrid();
  grid.columns.add(9);   // 9 columns now

  if (!grid.style) grid.style = {};
  grid.style.cellPadding = { left: 2, right: 3, top: 3, bottom: 3 };
  grid.style.font = font;

  const colP = (p) => tableW * p;

  const cQty   = colP(0.08);  // QUANTITY
  const cUnit  = colP(0.08);  // UNIT
  const cHS    = colP(0.09);  // HSCODE  ← NEW
  const cDesc  = colP(0.22);  // DESCRIPTION
  const cUP    = colP(0.10);  // UNIT PRICE
  const cVal   = colP(0.10);  // VALUE
  const cTR    = colP(0.09);  // TAX RATE
  const cTA    = colP(0.10);  // TAX AMT
  const cTot   = Math.floor(tableW - (cQty + cUnit + cHS + cDesc + cUP + cVal + cTR + cTA)); // TOTAL (remainder)

  grid.columns.getColumn(0).width = cQty;
  grid.columns.getColumn(1).width = cUnit;
  grid.columns.getColumn(2).width = cHS;
  grid.columns.getColumn(3).width = cDesc;
  grid.columns.getColumn(4).width = cUP;
  grid.columns.getColumn(5).width = cVal;
  grid.columns.getColumn(6).width = cTR;
  grid.columns.getColumn(7).width = cTA;
  grid.columns.getColumn(8).width = cTot;

  // Header row
  const header    = grid.headers.add(1)[0];
  const headerFmt = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);

  const headers = [
    "QUANTITY",
    "UNIT",
    "HS CODE",
    "DESCRIPTION OF GOODS",
    "UNIT\nPRICE",
    "VALUE OF\nGOODS",
    "RATE OF\nSALES\nTAX",
    "VALUE\nOF SALES\nTAX",
    "TOTAL VALUE"
  ];

  headers.forEach((h, i) => {
    header.cells.getCell(i).value = h;
    header.cells.getCell(i).style.font = fontBold;
    header.cells.getCell(i).style.stringFormat = headerFmt;
  });

  // Data rows
  let sumQty = 0, sumValue = 0, sumTax = 0, sumTotal = 0;

  (detailRows || []).forEach((r) => {
    const qty    = toNum(r?.Quantity);
    const rate   = toNum(r?.Rate);
    const bill   = toNum(r?.BillAmount) || (qty * rate);
    const taxPer = toNum(r?.TaxPercent);
    const taxAmt = toNum(r?.TaxAmount)  || (bill * (taxPer / 100));
    const total  = toNum(r?.TotalAmount) || (bill + taxAmt);

    sumQty   += qty;
    sumValue += bill;
    sumTax   += taxAmt;
    sumTotal += total;

    const row = grid.rows.addRow();

    row.cells.getCell(0).value = qty ? qty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
    row.cells.getCell(0).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);

    row.cells.getCell(1).value = r?.UnitOfMeasurement || "";
    row.cells.getCell(1).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

    // CHANGE 2: HSCODE
    row.cells.getCell(2).value = txt(r?.hS_CODE || "");
    row.cells.getCell(2).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

    row.cells.getCell(3).value = txt((r?.ProductDescription || '').toUpperCase());
    row.cells.getCell(3).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

    row.cells.getCell(4).value = rate.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(5).value = bill.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(6).value = taxPer.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(7).value = taxAmt.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(8).value = total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    [0, 4, 5, 6, 7, 8].forEach((c) => {
      row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
    });
  });

  // Total row
  const tr = grid.rows.addRow();
  tr.cells.getCell(0).value = sumQty ? sumQty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
  tr.cells.getCell(1).value = "";
  tr.cells.getCell(2).value = "";
  tr.cells.getCell(3).value = "";
  tr.cells.getCell(4).value = "";
  tr.cells.getCell(5).value = sumValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  tr.cells.getCell(6).value = "";
  tr.cells.getCell(7).value = sumTax.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  tr.cells.getCell(8).value = sumTotal.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  for (let i = 0; i < tr.cells.count; i++) {
    tr.cells.getCell(i).style.font = fontBold;
    tr.cells.getCell(i).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
  }

  y += 22;
  const result = grid.draw(page, { x: tableX, y });

  // =========================
  // CHANGE 3: SIGNATURE — Only PREPARED BY and RECEIVED BY (APPROVED BY removed)
  // =========================
  const signY    = result.bounds.y + result.bounds.height + 90;
  const lineW    = 120;
  const signFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Regular);
  const signPen  = new PdfPen(new PdfColor(0, 0, 0), 1);

  const leftX  = tableX + 50;
  const rightX = tableX + tableW - lineW - 50;

  const drawSign = (label, x) => {
    g.drawLine(signPen, x, signY, x + lineW, signY);
    const w = signFont.measureString(label).width;
    g.drawString(label, signFont, null, black, x + (lineW - w) / 2, signY + 6);
  };

  drawSign("PREPARED BY", leftX);
  drawSign("RECEIVED BY", rightX);

  // Outer border
  g.drawRectangle(outerPen, result.bounds.x, result.bounds.y, result.bounds.width, result.bounds.height);

  // Save
  let fileName = mainRow?.InvoiceType == "SS" ? 'SALE' : 'PURCHASE';
  const file = `INV_${fileName}_${invoiceNo}.pdf`;
  doc.save(file);
  doc.destroy();
  return null;
}
}




export default new InvoiceService();

